export interface HierarchyDocumentInfo {
  parentDocumentId?: string;
  childDocumentId?: string;
}
